module.exports = __webpack_public_path__ + "1e4c8c5e80114c365fc94ac7fe7fbde3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/mer-tail-coral-s.png
// module id = 1309
// module chunks = 0